import React from "react";

function NoMatchPage() {
  return <div>404 Not Found</div>;
}

export default NoMatchPage;
